import React, { useState } from 'react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const faqs = [{
    q: '¿Sirve si recién empiezo en Instagram?',
    a: 'Sí. El sistema está pensado para cualquier nivel, desde cero hasta cuentas con audiencia existente.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al completar tu compra recibís acceso inmediato por email en menos de 5 minutos. 100% digital en PDF.'
  }, {
    q: '¿Necesito saber de diseño o edición?',
    a: 'No. Todo está explicado paso a paso y los bonos incluyen plantillas listas para usar en Canva.'
  }, {
    q: '¿Funciona si soy de Argentina?',
    a: 'Sí. Todo el contenido está pensado en español rioplatense y adaptado al contexto argentino.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días de garantía total. Si no te sirve, te devolvemos el 100% sin preguntas ni formularios.'
  }];
  return <section className="py-[60px] px-5 bg-dark" data-id="element-64">
      <div className="max-w-[760px] mx-auto" data-id="element-65">
        <h2 className="text-[22px] md:text-[34px] font-black text-center mb-8 text-text-heading" data-id="element-66">
          ❓ Lo que más nos <span className="text-gold" data-id="element-67">preguntan</span>
        </h2>

        <div data-id="element-68">
          {faqs.map((faq, i) => <div key={i} className="border-b border-divider py-5" data-id="element-69">
              <button className="w-full flex justify-between items-center text-left text-[15px] font-bold text-white cursor-pointer" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-70">
                {faq.q}
                <span className="text-gold text-xl font-normal ml-4 shrink-0" data-id="element-71">
                  {openIndex === i ? '−' : '+'}
                </span>
              </button>
              {openIndex === i && <div className="text-[14px] text-text-muted leading-relaxed mt-3" data-id="element-72">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}